import Select from "components/Select";
import SuccessModalPc from "pagesPc/utils/modalCommonPc/SuccessModalPc";
import { FC, useEffect, useState } from "react";
import { IpropsModalSettings } from "types/modal/TypeModal";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";

const MapSettingModal: FC<IpropsModalSettings> = ({ onClose, open }) => {
  const [openModalSuccess, setOpenModalSuccess] = useState<boolean>(false);
  const options = [
    { name: "5", key: 0 },
    { name: "6", key: 1 },
    { name: "7", key: 2 },
    { name: "8", key: 3 },
    { name: "9", key: 4 },
    { name: "10", key: 5 },
    { name: "11", key: 6 },
    { name: "12", key: 7 },
    { name: "13", key: 8 },
    { name: "14", key: 9 },
    { name: "15", key: 10 },
    { name: "16", key: 11 },
    { name: "17", key: 12 },
    { name: "18", key: 13 },
    { name: "19", key: 14 },
    { name: "20", key: 15 },
    { name: "30", key: 16 },
    { name: "40", key: 17 },
    { name: "50", key: 18 },
    { name: "60", key: 19 },
  ];
  const GetActiveIndex = (item: string) => {
    return localStorage.getItem(item);
  };
  const activeIndexZoomON: any = GetActiveIndex("zoomOn");

  const data = [
    {
      enlabel: "firstZoom",
      label: "میزان زوم اولیه ",
      activeIndex: GetActiveIndex("firstZoom"),
    },
    {
      enlabel: "onlineZoom",
      label: "میزان زوم نمایش آنلاین",
      activeIndex: GetActiveIndex("onlineZoom"),
    },
    {
      enlabel: "simulatorZoom",
      label: "میزان زوم نمایش شبیه ساز",
      activeIndex: GetActiveIndex("simulatorZoom"),
    },
  ];

  const submit = () => {
    setOpenModalSuccess(true);
  };
  const showOpenModalSuccess = () => {
    setOpenModalSuccess(!openModalSuccess);
  };
  useEffect(() => {
    openModalSuccess && onClose();
  }, [openModalSuccess]);
  return (
    <>
      <SuccessModalPc
        open={openModalSuccess}
        onClose={showOpenModalSuccess}
        title={"تنظیمات با موفقیت تغییر یافت"}
      />
      <OverlayModalCommon onClose={onClose} open={open}>
        <div className="contentModalSettingsMapPc scrollbar-div">
          <div className="rowheaderModalSettingMap">
            <div onClick={onClose} className="icon3-close pointer" />
            <div className="titleheaderModal">تنظیمات نقشه</div>
          </div>
          {data?.map((data: any) => (
            <div className="rowBodyModalSettingMap" key={data.key}>
              <Select
                enlabel={data.enlabel}
                label={data.label}
                options={options}
                active={data.activeIndex}
                openModalSuccess={openModalSuccess}
              />
            </div>
          ))}
          <div className="rowBodyModalSettingMap">
            <Select
              enlabel="zoomOn"
              label={"زوم اولیه بر روی چه باشد"}
              options={[
                { name: "تمامی خودروها", key: 0 },
                { name: "آخرین خودروی آنلاین", key: 1 },
              ]}
              active={activeIndexZoomON}
              openModalSuccess={openModalSuccess}
            />
          </div>

          <div className="rowBtnSettingsMap">
            <div onClick={submit} className="BtnSettingsMapSubmit pointer">
              ذخیره
            </div>
            <div onClick={onClose} className="BtnSettingsMapCancel pointer">
              انصراف
            </div>
          </div>
        </div>
      </OverlayModalCommon>
    </>
  );
};
export default MapSettingModal;
